import '@mdi/font/css/materialdesignicons.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import colors from 'vuetify/lib/util/colors'

import Vue from 'vue'
import Vuetify from 'vuetify/lib'

const appleLightBlue = '#007AFF'
const appleDarkBlue = '#0A84FF'
const appleLightBrown = '#A2845E'
const appleDarkBrown = '#FFFFFF'
const appleLightCyan = '#32ADE6'
const appleDarkCyan = '#64D2FF'
const appleLightGreen = '#34C759'
const appleDarkGreen = '#30D158'
const appleLightIndigo = '#5856D6'
const appleDarkIndigo = '#5E5CE6'
const appleLightMint = '#00C7BE'
const appleDarkMint = '#66D4CF'
const appleLightOrange = '#FF9500'
const appleDarkOrange = '#FF9F0A'
const appleLightPink = '#FF2D55'
const appleDarkPink = '#FF375F'
const appleLightPurple = '#AF52DE'
const appleDarkPurple = '#BF5AF2'
const appleLightRed = '#FF3B30'
const appleDarkRed = '#FF453A'
const appleLightTeal = '#30B0C7'
const appleDarkTeal = '#40C8E0'
const appleLightYellow = '#FFCC00'
const appleDarkYellow = '#FFCC00'

const appleLightGray = '#8E8E93'
const appleDarkGray = '#8E8E93'
const appleLightGray2 = '#AEAEB2'
const appleDarkGray2 = '#636366'
const appleLightGray3 = '#C7C7CC'
const appleDarkGray3 = '#48484A'
const appleLightGray4 = '#D1D1D6'
const appleDarkGray4 = '#3A3A3C'
const appleLightGray5 = '#E5E5EA'
const appleDarkGray5 = '#2C2C2E'
const appleLightGray6 = '#F2F2F7'
const appleDarkGray6 = '#1C1C1E'
const appleWhite = '#ffffff'

const appleBackGroundLight = '#FAFAFA'
const appleAppBarLight = '#323233'

// Custom colors
const office = '#D53A00'
const tableHover = '#e07a3f'
const greenButtonLight = colors.green
const greenButtonDark = colors.green
const redButtonLight = colors.red.darken1
const redButtonDark = colors.red
const blueButtonLight = colors.blue
const blueButtonDark = colors.blue

Vue.use(Vuetify)

function isDark() {
const localStorageValue = window.localStorage.getItem('MyEduDark')
if (localStorageValue !== null) {
  return true
} else {
  return false
}
}

export default new Vuetify({
  iconfont: 'md',
  theme: {
    dark: isDark(),
    themes: {
      light: {
        primary: colors.blue.darken3,
        appBarColor: colors.grey.lighten5,
        navBarColor: colors.grey.lighten5,
        navBarLogoColor: blueButtonLight,
        background: colors.blueGrey.lighten5,
        historyBackground: appleWhite,
        vCard: appleBackGroundLight,
        vCardTitle: appleBackGroundLight,
        tableColor: colors.shades.white,
        error: appleLightRed,
        info: colors.blue.lighten2,
        success: appleLightGreen,
        warning: colors.amber.darken2,
        wifiDisabled: appleLightRed,
        wifiEnable: appleLightGreen,
        Disabled: appleLightRed,
        Enable: appleLightGreen,
        passwordInfo: appleDarkGray3,
        progressBar: colors.blue.accent2,
        checkBox: appleLightGreen,
        buttonValidate: colors.green.lighten1,
        buttonCancel: colors.red.lighten1,
        buttonAction: colors.blue.darken1,
        dialogTitle: appleDarkGray3,
        helpToolTip: colors.blue.accent2,
        office,
        tableHover,
        mainSelect: colors.shades.white,
      },
      dark: {
        primary: colors.green.darken3,
        appBarColor: appleDarkGray6,
        navBarColor: appleDarkGray6,
        navBarLogoColor: colors.blue.lighten2,
        background: appleDarkGray5,
        historyBackground: appleDarkGray4,
        vCard: appleDarkGray4,
        vCardTitle: appleDarkBlue,
        tableColor: appleDarkGray4,
        error: appleDarkRed,
        info: appleDarkOrange,
        success: appleDarkGreen,
        warning: appleDarkOrange,
        wifiDisabled: appleDarkRed,
        wifiEnable: appleDarkGreen,
        Disabled: appleLightRed,
        Enable: appleLightGreen,
        passwordInfo: appleDarkGray3,
        progressBar: colors.green.accent3,
        checkBox: appleDarkGreen,
        buttonValidate: colors.green.darken1,
        buttonCancel: colors.red.darken1,
        buttonAction: colors.green.darken3,
        dialogTitle: appleDarkGray6,
        helpToolTip: colors.green.darken3,
        office: colors.orange.accent2,
        tableHover,
        mainSelect: appleDarkGray4,
      },
    },
  },
  options: {
    customProperties: true,
  },
})
